{
  "nav": {
    "home": "Home",
    "pick": "Selectie",
    "leaderboard": "Klassement",
    "profile": "Profiel",
    "leagues": "Competities",
    "active_league": "Actieve Competitie"
  },
  "common": {
    "error_data": "Fout bij het laden van gegevens.",
    "stage": "Etappe",
    "go": "GA",
    "back": "← Terug",
    "one_day_race": "Eendagswedstrijd",
    "tomorrow": "Morgen",
    "in_days_one": "Morgen",
    "in_days_many": "Over {{count}} dagen",
    "in_days_other": "Over {{count}} dagen",
    "at_hours": "Om {{hours}} uur",
    "loading": "Laden...",
    "confirm": "BEVESTIGEN",
    "logout": "UITLOGGEN",
    "in_days": "Over {{count}} dagen",
    "error_generic": "Er is een fout opgetreden.",
    "optional": "optioneel",
    "tu": "JIJ",
    "error_title": "Fout",
    "send": "Versturen",
    "retry": "Opnieuw proberen",
    "load_error_title": "Kan de gegevens niet laden",
    "load_error_sub": "Controleer je verbinding en probeer het opnieuw.",
    "stale_data": "Gegevens mogelijk verouderd: opgeslagen gegevens getoond."
  },
  "home": {
    "participants": "deelnemers",
    "section_results": "Laatste resultaten",
    "section_upcoming": "Komende wedstrijden",
    "social": "Volg ons op social media",
    "onboarding_next": "Volgende →",
    "onboarding_start": "Begin met spelen →",
    "onboarding_rules": "Lees het reglement",
    "section_picks": "Selecties te maken",
    "no_races": "Momenteel geen wedstrijden om te selecteren",
    "other_picks_one": "nog een selectie te maken →",
    "other_picks_many": "nog {{count}} selecties te maken →",
    "other_picks_other": "nog {{count}} selecties te maken →",
    "stage_results": "Klassement",
    "tab_stage": "ETAPPE",
    "tab_gc": "ALGEMEEN",
    "no_data": "Geen gegevens beschikbaar",
    "onboarding_step1_title": "Welkom bij Virtua Cycling!",
    "onboarding_step1_body": "De fantasygame van het professionele wielrennen.",
    "onboarding_step2_title": "Zo werkt het",
    "onboarding_item1": "Kies je renners — Voor elke etappe kies je de renners waarop je inzet. Je hebt tot de start de tijd.",
    "onboarding_item2": "Verdien punten — Je renners scoren punten op basis van hun echte klassering in de etappe en het algemeen klassement.",
    "onboarding_item3": "Maak je competitie — Strijd etappe na etappe tegen andere deelnemers en klim in het algemeen klassement.",
    "onboarding_step3_title": "Je bent er klaar voor!",
    "onboarding_step3_body": "Je zit in de Virtua Cycling League, de algemene competitie waar iedereen speelt. Lees het volledige reglement om niets te missen.",
    "kofi_cta": "Vind je de app leuk? Trakteer ons op een biertje!",
    "jersey_gc": "Leiderstrui algemeen klassement",
    "jersey_pt": "Puntentrui",
    "jersey_gm": "Bergtrui",
    "greeting": "Hoi, {{name}}",
    "status_ready": "Keuzes bevestigd voor de volgende etappe",
    "status_todo": "Je hebt je keuzes nog niet gemaakt",
    "retry": "Opnieuw proberen"
  },
  "pick": {
    "live_label": "LIVE",
    "pick_done": "Selectie al gemaakt — je kunt hem nog wijzigen",
    "no_pick_stage": "Geen selectie gevonden voor deze etappe.",
    "error_load": "Fout bij het laden van de wedstrijden.",
    "loading": "Laden...",
    "title": "Selectie",
    "no_races_title": "Geen wedstrijd beschikbaar",
    "no_races_sub": "Er staan momenteel geen wedstrijden gepland. Kom snel terug!",
    "banned_title": "Uit koers",
    "banned_stages_one": "Je hebt 1 etappe overgeslagen",
    "banned_stages_many": "Je hebt {{count}} etappes overgeslagen",
    "banned_stages_other": "Je hebt {{count}} etappes overgeslagen",
    "banned_detail": "Je kunt de resultaten en selecties van anderen blijven volgen, maar je kunt niet meer meedoen aan deze editie.",
    "banned_message": "Tot de volgende keer!",
    "stage_finished": "Etappe afgelopen. Hier zijn de gemaakte selecties.",
    "live_alert": "Wedstrijd bezig — opstellingen vastgezet",
    "startlist_btn": "Startlijst",
    "startlist_title": "Startlijst",
    "startlist_search": "Zoek rugnummer of naam",
    "startlist_dnf": "Opgegeven",
    "startlist_empty": "Startlijst nog niet beschikbaar",
    "tab_insert": "Invoer",
    "tab_summary": "Overzicht",
    "start_list_title": "Startlijst nog niet klaar",
    "start_list_sub": "De deelnemerslijst wordt binnenkort gepubliceerd. Kom later terug.",
    "need_more_one": "Selecteer nog {{count}} renner.",
    "need_more_many": "Selecteer nog {{count}} renners.",
    "need_more_other": "Selecteer nog {{count}} renners.",
    "error_save": "Fout bij het opslaan.",
    "loading_riders": "Renners laden...",
    "draft_restored": "Concept hersteld",
    "draft_count_one": "1 renner lokaal opgeslagen",
    "draft_count_many": "{{count}} renners lokaal opgeslagen",
    "draft_count_other": "{{count}} renners lokaal opgeslagen",
    "draft_cancel": "Annuleren",
    "select_n_one": "Selecteer {{count}} renner",
    "select_n_many": "Selecteer {{count}} renners",
    "select_n_other": "Selecteer {{count}} renners",
    "add_rider": "+ Renner toevoegen ({{current}}/{{limit}})",
    "edit_selection": "Selectie bewerken",
    "apply_all": "Keuze toepassen op al mijn competities",
    "saved_for": "Opgeslagen voor: {{leagues}}",
    "flip_used": "Flip — gebruikt",
    "flip_available": "Flip — beschikbaar",
    "flip_remove": "Verwijderen",
    "flip_abbinato": "{{rider}} gekoppeld aan slot {{slot}}",
    "flip_confirmed": "De flip is aangemeld voor deze etappe. Bij de puntenberekening wordt de beste van de twee gekozen.",
    "flip_slot_label": "Aan welk slot koppel je de flip?",
    "flip_confirm_btn": "Flip bevestigen",
    "saving": "Opslaan...",
    "confirm_pick": "SELECTIE BEVESTIGEN {{current}}/{{limit}}",
    "select_riders": "Renners selecteren",
    "search_rider": "Renner zoeken...",
    "no_rider_found": "Geen renner gevonden",
    "compare_users": "Gebruikers vergelijken",
    "confirm": "Bevestigen",
    "no_pick_found": "Geen selectie gevonden.",
    "toast_multi_one": "Selecties opgeslagen voor 1 competitie",
    "toast_multi_many": "Selecties opgeslagen voor {{count}} competities",
    "toast_multi_other": "Selecties opgeslagen voor {{count}} competities",
    "toast_single": "Selecties opgeslagen!",
    "compare_with": "Vergelijk met {{names}}",
    "compare_default": "Vergelijk met andere gebruikers (max {{max}})",
    "tap_to_change": "• tik om te wijzigen",
    "you": "(JIJ)",
    "matrix_hint": "Tik op een renner om te zien wie hem koos",
    "user_col": "Gebruiker",
    "scout_title": "Scoutingrapport",
    "scout_top_rider": "Meest gekozen renner",
    "scout_distribution": "Verdeling per slot",
    "scout_variety": "Variatie in de competitie",
    "scout_distinct": "Verschillende gekozen renners",
    "scout_identical": "Identieke opstellingen",
    "scout_no_picks": "Maak je selectie om te zien hoeveel spelers dezelfde opstelling hebben als jij",
    "loading_lineups": "Opstellingen laden...",
    "collapse_all": "ALLES SLUITEN",
    "expand_all": "ALLES UITVOUWEN",
    "no_races": "Er zijn momenteel geen wedstrijden beschikbaar.",
    "add_rider_one": "+ Renner toevoegen ({{current}}/{{limit}})",
    "duplicate_rider": "{{name}} is al opgesteld in een eerdere etappe!",
    "draft_count": "Je hebt {{count}} renner(s) lokaal opgeslagen",
    "toast_multi": "Selecties opgeslagen voor {{count}} competities",
    "scout_chosen_by": "Gekozen door: {{names}}",
    "scout_chosen_by_others": "Gekozen door: {{names}} en {{count}} anderen",
    "scout_sharing": "Delen...",
    "scout_share_btn": "Scoutingrapport delen",
    "scout_outsider": "Outsider",
    "scout_contrarian": "Dapperste keuze",
    "scout_slot": "SLOT {{n}}",
    "scout_players": "{{count}} spelers",
    "draft_unsaved_banner": "Selectie niet bevestigd — druk op Bevestigen om op te slaan",
    "draft_unsaved_title": "Selectie niet bevestigd",
    "draft_unsaved_body": "Je hebt een niet-opgeslagen selectie. Wil je de selectie bevestigen voordat je vertrekt?",
    "draft_exit": "Vertrekken zonder opslaan",
    "draft_confirm_now": "Blijven en bevestigen",
    "share_all": "Allemaal",
    "current_league": "Huidige competitie",
    "duplicate_rider_reason": "Al gebruikt: {{name}}",
    "flip_saved": "Flip opgeslagen!",
    "flip_deleted": "Flip verwijderd.",
    "flip_add_rider": "+ Flip-renner toevoegen (optioneel)",
    "riders_count_one": "1 renner",
    "riders_count_many": "{{count}} renners",
    "riders_count_other": "{{count}} renners",
    "riders_selected_one": "1 geselecteerd",
    "riders_selected_many": "{{count}} geselecteerd",
    "riders_selected_other": "{{count}} geselecteerd",
    "search_user": "Gebruiker zoeken...",
    "tab_per_tappa": "Per etappe",
    "tab_matrice": "Aanwezigheid renners",
    "matrix_select_riders": "Kies de te volgen renners (max. 5)",
    "no_picks_riepilogo": "Geen selectie gevonden",
    "no_picks_riepilogo_sub": "Je hebt nog geen selectie gemaakt voor deze wedstrijd.",
    "scout_avg_pct": "~{{pct}}% gemiddeld",
    "scout_no_identical": "Niemand anders heeft dezelfde opstelling als jij",
    "scout_identical_count_one": "1 speler heeft dezelfde opstelling als jij",
    "scout_identical_count_many": "{{count}} spelers hebben dezelfde opstelling als jij",
    "scout_identical_count_other": "{{count}} spelers hebben dezelfde opstelling als jij",
    "scout_share_dialog": "Scoutingrapport — {{name}}",
    "share_hidden": "+ NOG {{count}} SPELERS · OPEN DE APP",
    "no_picks_tabella": "Geen opstelling ingediend",
    "no_picks_tabella_sub": "De selecties van andere spelers verschijnen hier.",
    "flip_slot_arrow": "→ slot {{slot}}",
    "race_tag_pick": "KIES",
    "race_tag_live": "LIVE",
    "race_tag_done": "AFGEROND",
    "race_switcher_label": "Wedstrijden",
    "race_history": "Wedstrijdgeschiedenis",
    "race_group_next": "Aankomende",
    "race_group_past": "Afgelopen",
    "close": "Sluiten",
    "prev_stage": "Vorige etappe",
    "next_stage": "Volgende etappe",
    "stage_list_title": "Etappes",
    "matrix_chosen_by": "{{name}} · gekozen door {{count}} van {{total}}",
    "matrix_clear": "Selectie wissen",
    "matrix_chosen_by_a11y": "gekozen door {{count}} van {{total}} spelers",
    "matrix_open_player": "Open de keuzes van {{name}}",
    "sheet_chosen_by": "{{count}} van {{total}}",
    "sheet_shared": "Zelfde als jij",
    "sheet_unique": "Unieke keuze",
    "share_label": "DE KEUZES",
    "share_most_picked": "MEEST GEKOZEN",
    "share_unique_picks": "UNIEKE KEUZES",
    "share_unique_sub": "renners door slechts één speler gekozen",
    "scout2_title": "Scout",
    "scout2_originality": "JOUW ORIGINALITEIT",
    "scout2_twin": "JOUW TWEELING",
    "scout2_identical": "IDENTIEKE KEUZES",
    "scout2_identical_sub": "spelers met dezelfde keuze",
    "scout2_bold": "Gedurfd",
    "scout2_balanced": "Gebalanceerd",
    "scout2_aligned": "Aangepast",
    "scout2_in_common": "{{count}} van {{total}} gemeen",
    "scout2_none": "Geen",
    "scout2_popularity": "Populariteit van de renners",
    "scout2_tap_hint": "Tik op een renner om hem in de tabel te markeren",
    "scout2_your_picks": "Jouw keuzes",
    "scout2_also_by": "Ook gekozen door {{names}}",
    "scout2_only_you": "Alleen jij",
    "scout2_outsiders": "Outsiders",
    "finished_banner": "Wedstrijd afgelopen · je bent {{pos}}e met {{pts}} pt",
    "finished_banner_nopos": "Wedstrijd afgelopen",
    "finished_cta": "Klassement",
    "scout2_like_you": "Wie speelde zoals jij",
    "scout2_twins_card": "JOUW TWEELINGEN",
    "scout2_same_as_you": "{{count}} met jouw keuze",
    "scout2_same_picks": "Zelfde keuze",
    "scout2_group_count": "{{count}} spelers",
    "scout2_no_common": "Geen renners gemeen met",
    "scout2_other_identical": "Andere identieke keuzes",
    "result_title": "Hoe het ging",
    "result_total": "Je scoorde {{pts}} pt",
    "result_pick_line": "voorspeld {{slot}}e · aangekomen {{rank}}e",
    "result_dnf": "niet geklasseerd",
    "result_best": "Jouw beste",
    "result_worst": "Kostte je het meest",
    "result_malus": "Winnaar niet gekozen",
    "result_bonus_top10": "Allemaal in de top 10",
    "result_bonus_top15": "Allemaal in de top 15",
    "result_winner": "De winnaar",
    "result_winner_owners": "gekozen door {{count}} van {{total}}",
    "result_nobody": "Niemand had hem",
    "result_difference": "Maakte het verschil",
    "result_difference_sub": "wie hem had scoorde gemiddeld {{delta}} pt t.o.v. de rest",
    "result_flop": "Liet velen zinken",
    "result_flop_sub": "wie hem had scoorde gemiddeld {{delta}} pt t.o.v. de rest",
    "rules_title": "Regels in het kort",
    "rules_1": "Eén renner per etappe, drie bij tijdritten.",
    "rules_2": "Een renner kan niet twee keer in dezelfde koers worden gebruikt.",
    "rules_3": "Mis je zelfs maar één etappe, dan ben je uit de koers: je kunt volgen, maar niet meespelen.",
    "rules_flip": "Flip: eenmalig per koers geef je een reserverenner op; hij telt in plaats van je renner alleen als hij beter finisht.",
    "profile_flat": "Vlak",
    "profile_hilly": "Heuvelachtig",
    "profile_mountain": "Bergen",
    "profile_itt": "Tijdrit",
    "profile_ttt": "Ploegentijdrit",
    "view_by_rider": "Per renner",
    "view_by_player": "Per speler",
    "tour_summary": "{{riders}} renners gekozen door {{players}} spelers",
    "your_pick": "Jouw keuze",
    "tour_your_result": "Jouw resultaat",
    "tour_stage_winner": "Etappewinnaar",
    "stage_finished_banner": "Etappe afgelopen · je bent {{pos}}e in de etappe ({{gap}})",
    "share_label_stage": "DE KEUZES VAN DE ETAPPE",
    "share_distinct_riders": "VERSCHILLENDE RENNERS",
    "scout_t_position": "JE ZIT IN DE",
    "scout_t_break": "KOPGROEP",
    "scout_t_small": "KLEINE GROEP",
    "scout_t_group": "PELOTON",
    "scout_t_with": "met {{count}} spelers",
    "scout_t_alone": "alleen jij",
    "scout_t_leader": "DE LEIDER KOOS",
    "scout_t_jerseys": "De truien: wat ze kozen",
    "scout_t_breakaway": "In de kopgroep",
    "closes_at": "Sluit {{when}}",
    "closes_in": "Sluit over {{time}}",
    "profile_title": "Hoogteprofiel",
    "profile_climbs": "Beklimmingen",
    "profile_coppi": "C = Cima Coppi",
    "profile_a11y": "Hoogteprofiel: {{km}} km, hoogste punt {{max}} m, {{n}} belangrijkste beklimmingen",
    "profile_sprint": "S = tussensprint",
    "profile_tap_climb": "Tik op een klim voor details",
    "profile_sprint_bonus": "Sprint · bonus",
    "climb_base": "Voet",
    "climb_summit": "Top",
    "climb_avg": "Gemiddeld stijgingspercentage",
    "climb_length": "Lengte",
    "profile_bonus": "B = bonuspunt"
  },
  "join": {
    "back_home": "Terug naar home",
    "welcome": "Welkom in de competitie!",
    "already_member": "Je bent al lid van deze competitie.",
    "error": "Kan niet aan de competitie deelnemen.",
    "joining": "Toegang tot de competitie...",
    "success": "Toegang verleend!"
  },
  "leaderboard": {
    "stage_cancelled": "Etappe {{n}} geannuleerd: telt niet mee voor het klassement",
    "loading": "Laden...",
    "no_result_title": "Geen resultaat",
    "no_result_sub": "De resultaten van deze wedstrijd zijn nog niet beschikbaar.",
    "gc_rank": "Algemeen Klassement",
    "team_no_data": "Geen teamgegevens voor deze etappe.",
    "team_title": "TEAMKLASSEMENT",
    "stage": "Etappe {{n}}",
    "general": "Algemeen",
    "stage_rank": "Etappeklassement {{n}}",
    "no_data_title": "Gegevens niet beschikbaar",
    "no_data_sub": "Het klassement voor deze etappe is nog niet berekend.",
    "one_day_race": "Eendagswedstrijd",
    "title": "Klassement",
    "no_data": "Geen gegevens beschikbaar.",
    "share": "Delen",
    "jersey_tempo": "Tijd",
    "jersey_punti": "Punten",
    "jersey_gpm": "Berg",
    "tab_individual": "Individueel",
    "tab_team": "Team",
    "share_text": "{{name}}\n\n{{text}}\n\n{{site}}",
    "sharing": "...",
    "race_tag_live": "BEZIG",
    "race_tag_done": "AFGEROND",
    "race_tag_soon": "BINNENKORT",
    "leader_label": "In de trui",
    "lead_over_second": "{{gap}} op de 2e",
    "winner": "Winnaar",
    "sheet_total": "Totaal",
    "tie": "gedeeld",
    "top10_count": "{{count}} in de top 10",
    "has_winner": "Heeft de winnaar",
    "my_rank": "Jouw positie",
    "counts_for_team": "Telt mee voor het team",
    "not_counting": "Telt niet mee",
    "share_label": "KLASSEMENT",
    "gap_above": "{{gap}} op nr. {{pos}}",
    "gap_below": "{{gap}} voor op nr. {{pos}}",
    "trend_up": "{{n}} plaatsen gestegen",
    "trend_down": "{{n}} plaatsen gezakt",
    "trend_same": "Positie ongewijzigd",
    "sheet_by_stage": "Etappe voor etappe"
  },
  "leagues": {
    "albo": "Erelijst",
    "no_podio": "heeft nog geen podiumplaatsen behaald.",
    "victories": "Overwinningen",
    "second": "2e plaats",
    "third": "3e plaats",
    "races_count_one": "1 wedstrijd",
    "races_count_many": "{{count}} wedstrijden",
    "races_count_other": "{{count}} wedstrijden",
    "player_a": "-- Speler A --",
    "player_b": "-- Speler B --",
    "draws_one": "1 gelijkspel",
    "draws_many": "{{count}} gelijkspelen",
    "draws_other": "{{count}} gelijkspelen",
    "on_races_one": "op 1 wedstrijd",
    "on_races_many": "op {{count}} wedstrijden",
    "on_races_other": "op {{count}} wedstrijden",
    "no_common": "Geen gemeenschappelijke wedstrijd met resultaten.",
    "settings": "INSTELLINGEN",
    "your_position": "Jouw positie",
    "stagionale": "Seizoensklassement",
    "hide": "VERBERGEN",
    "show_all_one": "TOON ALLES (1 andere)",
    "show_all_many": "TOON ALLES ({{count}} andere)",
    "show_all_other": "TOON ALLES ({{count}} andere)",
    "no_data": "Nog geen gegevens beschikbaar.",
    "head2head": "Head to head",
    "races_count": "{{count}} wedstrijden",
    "draws": "{{count}} gelijk",
    "on_races": "op {{count}} wedstrijden",
    "show_all": "TOON ALLES ({{count}} andere)",
    "badge_empty_1": "Nog geen badges — de roem wacht op je! 🚴",
    "badge_empty_2": "Nul prestaties tot nu toe, maar elke wedstrijd is een kans. 💪",
    "badge_empty_3": "Nog steeds geen badges — grote kampioenen beginnen bij nul. 🏅",
    "badge_empty_4": "De eerste badge is altijd het moeilijkst. We zijn er bijna! ⚡",
    "gap_to_podium": "{{gap}} pt van het podium",
    "gap_to_prev": "{{gap}} pt achter nr. {{pos}}",
    "lead_over_next": "+{{gap}} pt voor op nr. {{pos}}",
    "invite_title": "Speel je alleen?",
    "invite_body": "Nodig je vrienden uit om samen in deze competitie te spelen.",
    "invite_cta": "Vrienden uitnodigen",
    "pick_member": "Kies een speler",
    "position_a11y": "Positie {{pos}}",
    "load_error": "De competitie kon niet worden geladen.",
    "tab_standings": "Klassement",
    "tab_stats": "Statistieken",
    "tab_rivalry": "Uitdagingen"
  },
  "league": {
    "member_count_one": "1 gebruiker in deze competitie",
    "member_count_many": "{{count}} gebruikers in deze competitie",
    "member_count_other": "{{count}} gebruikers in deze competitie",
    "index_join": "Deelnemen",
    "index_create": "Competitie aanmaken",
    "manage_title": "Beheer {{name}}",
    "err_name": "Voer een naam in",
    "err_password": "Voer een wachtwoord in",
    "err_creation": "Fout bij het aanmaken",
    "create_title": "Nieuwe competitie aanmaken",
    "create": "Competitie aanmaken",
    "privacy": "Privacy",
    "public": "Openbaar",
    "private": "Privé",
    "err_join": "Fout of je bent al ingeschreven",
    "join_title": "Deelnemen aan een competitie",
    "search_placeholder": "Zoek op naam...",
    "search": "Zoeken",
    "no_leagues_found": "Geen competitie gevonden",
    "join_btn": "Deelnemen",
    "password_insert": "Voer het wachtwoord in:",
    "calendar_section": "Kalender",
    "calendar_desc_admin": "Beheer de wedstrijden van de competitie",
    "calendar_desc_user": "Wedstrijden in de kalender",
    "manage": "Beheren",
    "view": "Bekijken",
    "calendar_title": "Kalender van de competitie",
    "calendar_save_one": "Kalender opslaan (1 wedstrijd)",
    "calendar_save_many": "Kalender opslaan ({{count}} wedstrijden)",
    "calendar_save_other": "Kalender opslaan ({{count}} wedstrijden)",
    "races_selected_one": "1 wedstrijd geselecteerd",
    "races_selected_many": "{{count}} wedstrijden geselecteerd",
    "races_selected_other": "{{count}} wedstrijden geselecteerd",
    "deselect_all": "Alles deselecteren",
    "select_all": "Alles selecteren",
    "loading": "Laden...",
    "settings_section": "Competitie-instellingen",
    "settings_name": "Naam van de competitie",
    "settings_save": "Opslaan",
    "settings_autopick": "Automatische selectie",
    "settings_autopick_desc": "Als een gebruiker geen selectie maakt, kiest het systeem de beste beschikbare renner van de vorige etappe.",
    "settings_team_race": "Teamwedstrijd",
    "settings_team_race_desc": "Activeer de teammodus voor deze competitie.",
    "settings_team_size": "Max. leden per team",
    "settings_scoring": "Puntenberekening",
    "settings_scoring_best2": "Beste 2 — som van de eerste twee",
    "settings_scoring_avg": "Gemiddelde van alle leden",
    "settings_flip": "Flip",
    "settings_flip_desc": "Elke gebruiker kan een jokerrenner opgeven voor een etappe naar keuze. Bij de puntenberekening wordt automatisch de beste gekozen tussen de vaste renner en de flip. Slechts één keer per wedstrijd te gebruiken.",
    "invite_section": "Uitnodigingslink",
    "invite_loading": "Laden...",
    "invite_copied": "Gekopieerd!",
    "invite_copy": "Kopiëren",
    "invite_share_btn": "Delen",
    "members_section": "Leden",
    "members_title_admin": "Ledenbeheer",
    "members_title_user": "Leden van de competitie",
    "leaving": "Verlaten...",
    "leave": "Deze competitie verlaten",
    "admin_badge": "Admin",
    "remove": "Verwijderen",
    "pick_admin_title": "Selectie corrigeren",
    "pick_admin_desc": "Bewerk de selecties van gebruikers",
    "pick_admin_open": "Openen",
    "pick_admin_save": "Selecties opslaan",
    "pick_admin_none": "— niemand —",
    "pick_admin_search": "Zoek renner of rugnummer",
    "pick_admin_retired": "opgegeven",
    "pick_admin_saved2": "{{set}} keuzes gezet, {{removed}} verwijderd",
    "pick_admin_nochange": "Geen wijzigingen om op te slaan",
    "pick_admin_undo": "Laatste correctie ongedaan maken",
    "pick_admin_undone": "Correctie ongedaan gemaakt",
    "pick_admin_future": "Ook {{n}} keuzes van toekomstige etappes met dezelfde renner verwijderd",
    "pick_admin_notify": "Spelers waarschuwen",
    "pick_admin_no_calendar": "Deze koers staat niet in de competitiekalender: opslaan niet mogelijk",
    "stats_section": "Statistieken",
    "stats_participation": "Deelname per etappe",
    "stats_title": "Deelnamestatistieken",
    "stats_no_data": "Geen gegevens beschikbaar.",
    "stats_error": "Statistieken konden niet worden geladen. Probeer het opnieuw.",
    "team_loading": "Team laden...",
    "team_section": "Team",
    "team_cancel": "Annuleren",
    "team_create_btn": "+ Team aanmaken",
    "team_locked": "Wedstrijd bezig — teamwijzigingen uitgeschakeld",
    "team_create": "Team aanmaken",
    "team_members_count_one": "1/{{max}} lid",
    "team_members_count_many": "{{count}}/{{max}} leden",
    "team_members_count_other": "{{count}}/{{max}} leden",
    "team_invite_btn": "+ Uitnodigen",
    "team_leave": "Verlaten",
    "team_save": "Opslaan",
    "team_pwd_hint": "Laat leeg om openbaar te maken",
    "team_pending": "Wacht op antwoord",
    "team_invite_cancel": "Annuleren",
    "team_invite_section": "Een lid uitnodigen",
    "team_no_invitable": "Geen lid beschikbaar om uit te nodigen.",
    "team_invite_action": "Uitnodigen",
    "team_private_label": "\"{{name}}\" is privé:",
    "team_join_action": "Binnengaan",
    "team_empty": "Nog geen team — wees de eerste die er een aanmaakt!",
    "team_mine": "JOUW TEAM",
    "team_join": "Deelnemen",
    "team_full": "Vol",
    "team_members": "Leden",
    "join": "Deelnemen",
    "calendar_save": "Kalender opslaan ({{count}} wedstrijden)",
    "invite_share": "Delen",
    "races_selected": "{{count}} wedstrijden geselecteerd",
    "invite_desc": "Deel deze link — wie erop klikt, komt direct in de competitie terecht.",
    "invite_desc_pwd": "Deel deze link — wie erop klikt, komt direct in de competitie terecht met het wachtwoord al inbegrepen.",
    "member_count": "{{count}} gebruikers in deze competitie",
    "team_members_count": "{{count}}/{{max}} leden",
    "create_name_placeholder": "Bijv.: De Trapvrienden",
    "create_password_placeholder": "Toegangswachtwoord",
    "calendar_saved": "Kalender opgeslagen!",
    "err_name_empty": "De naam mag niet leeg zijn",
    "settings_saved": "Instellingen opgeslagen!",
    "pwd_public_placeholder": "Laat leeg voor een openbare competitie",
    "invite_share_title": "Sluit je aan bij {{name}} op Virtua Cycling",
    "invite_share_message": "Sluit je aan bij de competitie \"{{name}}\" op Virtua Cycling!\n{{url}}",
    "invite_regen_confirm": "Link opnieuw genereren? Alle eerdere links werken dan niet meer.",
    "invite_regenerating": "Opnieuw genereren...",
    "invite_regen_btn": "Link opnieuw genereren (herroept eerdere)",
    "confirm_remove": "{{name}} verwijderen uit de competitie?",
    "member_removed": "{{name}} verwijderd",
    "confirm_demote": "Wil je de adminrechten van {{name}} intrekken?",
    "confirm_promote": "Wil je {{name}} promoveren tot admin?",
    "demote_admin": "Admin verwijderen",
    "promote_admin": "Admin",
    "pick_admin_saved": "{{count}} selecties opgeslagen!",
    "confirm_team_leave": "Het team verlaten?",
    "confirm_kick": "{{name}} uit het team verwijderen?",
    "team_invite_sent": "Uitnodiging verstuurd!",
    "team_pwd_saved": "Wachtwoord bijgewerkt!",
    "team_name_placeholder": "Teamnaam...",
    "team_rename_placeholder": "Nieuwe naam...",
    "team_newpwd_placeholder": "Nieuw wachtwoord..."
  },
  "profile": {
    "nick_title": "Bijnaam",
    "theme_title": "Thema-aanpassing",
    "theme_dark": "Donker",
    "theme_light": "Licht",
    "lang": "Taal",
    "save_lang": "Taal opslaan",
    "nick_success": "Bijnaam bijgewerkt!",
    "nick": "Bijnaam",
    "nick_placeholder": "Voer bijnaam in",
    "update_btn": "Bijwerken",
    "pass": "Wachtwoord",
    "show_pass": "Wachtwoord tonen",
    "update_pass": "Wachtwoord bijwerken",
    "avatars_title": "Avatars",
    "avatars": "Avatars tonen",
    "avatars_sub": "Zet het uit als je telefoon traag is: in plaats van avatars zie je de shirts van de renners en de namen van de spelers. Je avatar op het startscherm blijft.",
    "notif_title": "Pushmeldingen",
    "my_leagues": "Mijn competities",
    "members_count_one": "1 lid",
    "members_count_many": "{{count}} leden",
    "members_count_other": "{{count}} leden",
    "default_badge": "STANDAARD",
    "set_default": "Instellen als standaard",
    "leave": "Verlaten",
    "settings": "Profielinstellingen",
    "hi": "Hoi",
    "intro": "hier kun je je account beheren.",
    "admin_panel": "Beheerpaneel",
    "theme_sub": "Gesynchroniseerd op al je apparaten.",
    "lang_title": "Taal / Language",
    "security_title": "Toegang en beveiliging",
    "security_success": "Gegevens bijgewerkt!",
    "notif_enabled": "Meldingen inschakelen",
    "notif_enabled_sub": "Schakel alle meldingen in of uit",
    "notif_results": "Wedstrijdresultaten",
    "notif_results_sub": "Melding wanneer de resultaten worden gepubliceerd",
    "notif_startlist": "Startlijst",
    "notif_startlist_sub": "Melding zodra de startlijst beschikbaar is",
    "notif_reminder": "Herinnering selectie",
    "notif_reminder_sub": "Ontvang een herinnering voor het sluiten van de selecties",
    "notif_reminder_off": "Geen herinnering",
    "notif_reminder_no_pick": "Alleen als ik nog niet gekozen heb",
    "notif_reminder_always": "Altijd",
    "notif_saving": "Opslaan...",
    "notif_saved": "Voorkeuren opgeslagen!",
    "notif_error": "Fout bij het opslaan",
    "nick_taken": "Bijnaam al in gebruik",
    "pass_min_length": "Het wachtwoord moet minstens 6 tekens bevatten",
    "pass_mismatch": "De wachtwoorden komen niet overeen",
    "new_pass_placeholder": "Nieuw wachtwoord",
    "league_default_updated": "Standaardcompetitie bijgewerkt!",
    "league_leave_confirm": "Weet je zeker dat je \"{{name}}\" wilt verlaten?",
    "league_left": "Competitie verlaten.",
    "confirm_password": "Bevestig wachtwoord",
    "avatar_title": "Jouw avatar",
    "avatar_jersey": "Shirt",
    "avatar_cap": "Petje",
    "avatar_glasses": "Bril",
    "avatar_cyclist": "Wielrenner",
    "avatar_patch": "Shirt-patch",
    "avatar_saved": "Avatar opgeslagen!",
    "avatar_save_btn": "Avatar opslaan",
    "rules": "Reglement",
    "report_bug": "Een probleem melden",
    "bug_sent": "Melding verzonden, bedankt!",
    "bug_placeholder": "Beschrijf het probleem...",
    "group_identity": "Identiteit",
    "group_account": "Account",
    "group_contact": "Neem contact op",
    "group_danger": "Gevarenzone",
    "change_pass": "Wijzigen",
    "cancel": "Annuleren",
    "show_more": "Toon alle ({{count}} meer)",
    "show_less": "Toon minder",
    "delete_confirm": "Weet je zeker dat je je account wilt verwijderen? Dit kan niet ongedaan worden gemaakt en al je gegevens worden definitief verwijderd.",
    "delete_desc": "Verwijderen is permanent en wist al je gegevens, keuzes, competities en voorkeuren.",
    "delete_btn": "Mijn account verwijderen",
    "delete_league_owner": "Je hebt een competitie met andere leden aangemaakt: als je je account verwijdert, verdwijnt die voor iedereen. Neem contact op om hem over te dragen, of verwijder hem eerst.",
    "replay_tour": "Bekijk de tour opnieuw",
    "leave_feedback": "Feedback geven",
    "feedback_placeholder": "Een idee, suggestie of opmerking: we horen het graag...",
    "feedback_sent": "Bedankt voor je feedback! 🙏",
    "rate_app": "Beoordeel Virtua Cycling ⭐"
  },
  "login": {
    "err_nickname": "Voer een bijnaam in",
    "err_nickname_taken": "Bijnaam al in gebruik",
    "register_ok": "Registration completed! Check your email and confirm your account before logging in.",
    "err_email": "Voer je e-mailadres in",
    "forgot_sent": "E-mail verzonden! Controleer je inbox.",
    "tagline": "Neem je plaats in de volgwagen in.",
    "tab_login": "Inloggen",
    "tab_register": "Registreren",
    "forgot_hint": "Voer je e-mailadres in en we sturen je een link om je wachtwoord opnieuw in te stellen.",
    "email": "E-mail",
    "forgot_send": "Link versturen",
    "back": "← Terug naar inloggen",
    "nickname": "Bijnaam",
    "password": "Wachtwoord",
    "btn_login": "INLOGGEN",
    "btn_register": "REGISTREREN",
    "forgot_pass": "Wachtwoord vergeten?",
    "or": "of",
    "google_login": "Inloggen met Google",
    "google_register": "Registreren met Google",
    "privacy_text": "Door verder te gaan accepteer je ons",
    "privacy_link": "Privacybeleid",
    "loading": "…"
  },
  "news": {
    "title": "NIEUWS",
    "loading": "Laden...",
    "no_news": "Geen nieuws beschikbaar.",
    "pinned": "Uitgelicht",
    "not_found": "Artikel niet gevonden.",
    "open_external": "Open het artikel op {{source}}",
    "disclaimer": "Koppen en links komen van externe bronnen: de artikelen zijn eigendom van de uitgevers.",
    "tab_unread_one": "{{count}} nieuw bericht",
    "tab_unread_other": "{{count}} nieuwe berichten",
    "load_error": "Het nieuws kon niet worden geladen."
  },
  "reset_password": {
    "title": "NIEUW WACHTWOORD",
    "subtitle": "Kies een nieuw wachtwoord voor je account",
    "show_pass": "Wachtwoord tonen",
    "loading": "Link wordt gecontroleerd...",
    "success": "Wachtwoord bijgewerkt! Je wordt doorgestuurd..."
  },
  "confirm": {
    "verifying": "Verifiëren...",
    "error": "Fout tijdens bevestiging.",
    "success": "E-mail bevestigd! Je wordt doorgestuurd...",
    "missing_params": "Ontbrekende parameters in de link.",
    "missing_params_detail": "Zorg ervoor dat je op de juiste link uit je e-mail hebt geklikt.",
    "critical_error": "Kritieke verbindingsfout."
  },
  "notifications": {
    "title": "Meldingen",
    "empty": "Nog geen meldingen",
    "accept": "Accepteren",
    "refuse": "Weigeren",
    "now": "Nu",
    "minutes_ago": "{{count}} min geleden",
    "hours_ago": "{{count}}u geleden"
  },
  "quiz": {
    "card_sub": "10 vragen over de Tour de France — hoeveel weet jij?",
    "loading": "Vragen laden...",
    "no_questions": "Geen vraag beschikbaar",
    "question_count": "Vraag {{current}} van {{total}}",
    "easy": "Makkelijk",
    "medium": "Gemiddeld",
    "hard": "Moeilijk",
    "correct": "Goed antwoord!",
    "wrong": "Fout. Het antwoord was: {{answer}}",
    "next": "Volgende",
    "see_result": "Bekijk resultaat",
    "restart": "Opnieuw spelen",
    "result_excellent": "Je bent een echte wielerexpert!",
    "result_good": "Uitstekende kennis van de Tour de France!",
    "result_average": "Redelijke kennis. Bekijk meer wedstrijden!",
    "result_poor": "Er is ruimte voor verbetering — maar daarom fiets je juist!"
  },
  "person": {
    "hint": "Kies hoe je avatar eruitziet: je ziet hem op het startscherm.",
    "gender": "Geslacht",
    "man": "Man",
    "woman": "Vrouw",
    "hair_short": "Kort",
    "hair_curly": "Krullend",
    "hair_wavy": "Golvend",
    "hair_shaved": "Kaalgeschoren",
    "hair_pixie": "Pixie",
    "hair_bob": "Bob",
    "headwear": "Hoofddeksel",
    "wear_none": "Geen",
    "wear_cap": "Pet",
    "wear_helmet": "Helm",
    "glasses": "Bril",
    "glasses_off": "Nee",
    "glasses_on": "Ja",
    "jersey": "Shirt",
    "jersey_vertical": "Verticaal",
    "jersey_horizontal": "Horizontaal",
    "jersey_classic": "Klassiek",
    "jersey_diagonal": "Diagonaal",
    "jersey_dots": "Stippen",
    "row_skin": "Huid",
    "row_hair": "Haar",
    "row_brow": "Wenkbrauwen",
    "row_iris": "Ogen",
    "row_wear": "Hoofddeksel",
    "row_visor": "Klep",
    "row_vents": "Ventilatieopeningen",
    "row_frame": "Brilmontuur",
    "save": "OPSLAAN",
    "saved": "Avatar opgeslagen",
    "save_error": "Fout bij opslaan",
    "reset": "Herstellen",
    "reset_done": "Hersteld",
    "tab_face": "Gezicht",
    "tab_hair": "Haar",
    "tab_gear": "Accessoires",
    "tab_jersey": "Shirt",
    "row_lens": "Glazen",
    "jersey_body": "Lichaam",
    "jersey_sleeves": "Mouwen",
    "jersey_band": "Band",
    "jersey_trim": "Kraag en manchetten",
    "view_mine": "Mijn avatar",
    "view_world_champion": "Regenboogtrui",
    "world_champion_since": "Wereldkampioen in {{league}} sinds {{date}}",
    "view_european_champion": "Europese trui",
    "european_champion_since": "Europees kampioen in {{league}} sinds {{date}}",
    "view_worldcup_leader": "Wereldbekertrui",
    "worldcup_leader_since": "Leider van het klassement van {{league}} sinds {{date}}",
    "kits_show": "Show team kits (admin)",
    "kits_hide": "Hide team kits",
    "kits_hint": "Team jerseys imported from PCS: check colours and design. Kits are fixed in the database.",
    "kits_approx": "approximate",
    "kits_men": "Men",
    "kits_women": "Women",
    "kits_wt": "WorldTeam",
    "kits_pro": "ProTeam",
    "kits_tap": "tap a team to see its riders",
    "kits_no_riders": "No avatars for this team yet.",
    "avatar_edit": "Avatar bewerken",
    "avatar_cut": "Kapsel",
    "avatar_hair": "Haar",
    "avatar_skin": "Huid",
    "avatar_beard": "Baard",
    "avatar_beard_none": "Geen",
    "avatar_face": "Gezicht",
    "avatar_face_none": "Standaard",
    "avatar_face_a": "Smal",
    "avatar_face_b": "Stevig",
    "avatar_face_c": "Jong",
    "avatar_face_d": "Hoekig",
    "avatar_face_e": "Volwassen",
    "avatar_face_f": "Lachend",
    "avatar_face_g": "Gesloten glimlach",
    "avatar_brow": "Wenkbrauwen",
    "avatar_brow_0": "Normaal",
    "avatar_brow_1": "Dun",
    "avatar_brow_2": "Dik",
    "avatar_beard_light": "Licht",
    "avatar_hex": "Andere kleur (#RRGGBB)",
    "avatar_save": "Opslaan",
    "avatar_reset": "Herstellen",
    "avatar_undo": "Laatste wijziging ongedaan maken",
    "avatar_saved": "Opgeslagen",
    "avatar_bad_hex": "Ongeldige kleur: gebruik #RRGGBB",
    "avatar_err": "Opslaan mislukt",
    "avatar_beard_legend": "1 stoppels · 2 snor · 3 kort · 4 vol · 6 snor+sik · 7 cirkelbaard · 8 lichte stoppels",
    "hair_wavy_medium": "Halflang golvend",
    "hair_receding": "Terugwijkend",
    "hair_messy": "Warrig",
    "hair_buzz": "Kortgeschoren",
    "hair_curly_short": "Korte krullen",
    "hair_medium": "Schouderlengte",
    "hair_flip_off": "Normale kant",
    "hair_flip_on": "Gespiegeld",
    "hair_side_part": "Zijscheiding",
    "hair_slicked_back": "Naar achteren",
    "hair_forward": "Naar voren",
    "hair_high_line": "Hoge haarlijn",
    "hair_wavy_short": "Kort golvend",
    "hair_curly_medium": "Halflange krullen",
    "hair_receding_short": "Kort met inhammen",
    "beard_stubble_light": "Lichte stoppels",
    "hair_long": "Lang",
    "hair_ponytail": "Paardenstaart",
    "hair_bun": "Knot",
    "hair_long_wavy": "Golvend",
    "hair_braid": "Vlecht",
    "beard": "Baard",
    "beard_none": "Geen",
    "beard_stubble": "Stoppels",
    "beard_moustache": "Snor",
    "beard_short": "Kort",
    "beard_full": "Vol",
    "beard_goatee": "Snor en sik",
    "beard_circle": "Cirkelbaard",
    "beard_op_normal": "Normaal",
    "beard_op_light": "Licht",
    "fringe": "Pony",
    "fringe_off": "Zonder",
    "fringe_on": "Met pony"
  },
  "app_update": {
    "title": "Nieuwe versie klaar",
    "body": "Herstart de app om de nieuwste wijzigingen te gebruiken.",
    "restart": "Herstart",
    "later": "Later"
  },
  "avatar": {
    "invite_title": "Dit is je avatar!",
    "invite_body": "We hebben er een voor je gemaakt: pas hem aan zoals je wilt.",
    "invite_cta": "Aanpassen",
    "invite_dismiss": "Sluiten",
    "edit_a11y": "Pas je avatar aan"
  },
  "jersey_celebration": {
    "ok": "Geweldig!"
  },
  "insight": {
    "you": "Met jou",
    "form": "Vorm",
    "never": "Nog nooit door jou gekozen: dit zou de eerste keer zijn.",
    "picked": "Keer gekozen",
    "avg_rank": "Gemiddelde plaats",
    "avg_gap": "Gemiddelde achterstand",
    "best": "Beste resultaat",
    "dnf": "Opgaven met jou",
    "last": "Laatste keer",
    "retired": "opgegeven",
    "form_avg": "Gemiddelde laatste 5",
    "season_races": "Wedstrijden dit seizoen",
    "top10": "Top 10",
    "wins": "Overwinningen",
    "dnfs": "Opgaven",
    "cat_1": "Vlakke etappes",
    "cat_2": "Bergetappes",
    "cat_3": "Heuvelachtige etappes",
    "last5": "Laatste 5 resultaten",
    "no_results": "Nog geen resultaten dit seizoen.",
    "open_a11y": "Inzichten over {{name}}",
    "summary": "{{n}}× met jou · gem. {{rank}}e",
    "summary_never": "Nog nooit door jou gekozen",
    "open": "Inzichten"
  },
  "badges": {
    "title": "Badges",
    "album_title": "Prijzenkast",
    "earned_of": "{{earned}} van {{total}} badges",
    "open_album": "Prijzenkast openen",
    "recent": "Laatst behaald",
    "next_goals": "Doelen binnen bereik",
    "filter_all": "Alle",
    "filter_earned": "Behaald",
    "filter_todo": "Te behalen",
    "group_gt": "Grote Rondes",
    "group_monuments": "Monumenten en klassiekers",
    "group_picks": "Keuzevaardigheid",
    "group_consistency": "Regelmaat",
    "group_league": "Competitieklassement",
    "group_social": "Sociaal",
    "group_meta": "Collectie",
    "tier_1": "Brons",
    "tier_2": "Zilver",
    "tier_3": "Goud",
    "tier_4": "Platina",
    "tier_special": "Mijlpaal",
    "secret_title": "Geheime badge",
    "secret_hint": "Ontdek het al spelend.",
    "earned_on": "Behaald op {{date}}",
    "progress": "{{value}} van {{threshold}}",
    "rarity": "{{pct}}% van de competitie heeft hem ({{n}} van {{m}})",
    "rarity_none": "Niemand heeft hem nog: jij kunt de eerste zijn.",
    "seasons": "Behaalde seizoenen: {{count}}",
    "complete": "Voltooid",
    "locked": "Te behalen",
    "player": "Speler",
    "none_me": "Nog geen badges: de volgende koers is je kans.",
    "none_other": "{{name}} heeft nog geen badges.",
    "empty_filter": "Niets te tonen met dit filter.",
    "load_error": "De badges konden niet worden geladen.",
    "not_enabled": "Badges zijn nog niet actief voor deze competitie.",
    "fam": {
      "RE_GT": {
        "title": "Koning van de Grote Rondes",
        "desc": "Gewonnen Grote Rondes: {{n}}"
      },
      "WIN_GIRO": {
        "title": "Koning van de Giro",
        "desc": "Win het algemeen klassement van de Giro d'Italia"
      },
      "WIN_TOUR": {
        "title": "Koning van de Tour",
        "desc": "Win het algemeen klassement van de Tour de France"
      },
      "WIN_VUELTA": {
        "title": "Koning van de Vuelta",
        "desc": "Win het algemeen klassement van de Vuelta"
      },
      "GT_PODI": {
        "title": "Podia in de Grote Rondes",
        "desc": "Podiumplaatsen in Grote Rondes: {{n}}"
      },
      "GT_DAYS": {
        "title": "Dagen in de trui",
        "desc": "Dagen als leider van het algemeen klassement: {{n}}"
      },
      "FIRST_PINK": {
        "title": "Roze trui",
        "desc": "Neem de leiding in het algemeen klassement van de Giro d'Italia"
      },
      "FIRST_YELLOW": {
        "title": "Gele trui",
        "desc": "Neem de leiding in het algemeen klassement van de Tour de France"
      },
      "FIRST_RED": {
        "title": "Rode trui",
        "desc": "Neem de leiding in het algemeen klassement van de Vuelta"
      },
      "GT_GREEN": {
        "title": "Koning van de sprinters",
        "desc": "Gewonnen puntenklassementen in Grote Rondes: {{n}}"
      },
      "GT_POIS": {
        "title": "Koning van de bergen",
        "desc": "Gewonnen bergklassementen in Grote Rondes: {{n}}"
      },
      "GT_STAGE_WINS": {
        "title": "Etappejager",
        "desc": "Gewonnen etappes in Grote Rondes: {{n}}"
      },
      "GT_WIRE": {
        "title": "Van start tot finish",
        "desc": "Leid het klassement van de eerste tot de laatste etappe en win de Grote Ronde"
      },
      "GT_COMEBACK": {
        "title": "Wederopstanding",
        "desc": "Win een Grote Ronde terwijl je na de eerste week buiten de top 10 stond"
      },
      "GT_TRIPLE_JERSEY": {
        "title": "Totale triomf",
        "desc": "Win algemeen, punten en berg in dezelfde Grote Ronde"
      },
      "GT_HEARTBREAK": {
        "title": "De pijnlijke misser",
        "desc": "Je leidde op de vooravond van de laatste etappe, maar won de Grote Ronde niet"
      },
      "TRIPLE_CROWN": {
        "title": "Triple Crown",
        "desc": "Win de Giro, de Tour en de Vuelta"
      },
      "THE_DOUBLE": {
        "title": "The Double",
        "desc": "Win de Giro en de Tour in hetzelfde jaar"
      },
      "RE_MONUMENTI": {
        "title": "Koning van de Monumenten",
        "desc": "Gewonnen Monumenten: {{n}}"
      },
      "WIN_SANREMO": {
        "title": "La Classicissima",
        "desc": "Win Milaan-San Remo"
      },
      "WIN_FIANDRE": {
        "title": "De Ronde",
        "desc": "Win de Ronde van Vlaanderen"
      },
      "WIN_ROUBAIX": {
        "title": "Hel van het Noorden",
        "desc": "Win Parijs-Roubaix"
      },
      "WIN_LIEGI": {
        "title": "La Doyenne",
        "desc": "Win Luik-Bastenaken-Luik"
      },
      "WIN_LOMBARDIA": {
        "title": "De koers van de vallende bladeren",
        "desc": "Win de Ronde van Lombardije"
      },
      "MONUMENTS_SWEEP": {
        "title": "Alle Monumenten",
        "desc": "Win alle 5 Monumenten"
      },
      "RE_DEL_NORD": {
        "title": "Koning van het Noorden",
        "desc": "Win Vlaanderen en Roubaix in hetzelfde jaar"
      },
      "ARDENNES": {
        "title": "Ardennen-triple",
        "desc": "Win de Amstel, de Waalse Pijl en Luik in hetzelfde jaar"
      },
      "DUE_MARI": {
        "title": "Koers van de twee zeeën",
        "desc": "Win Parijs-Nice en Tirreno-Adriatico in hetzelfde jaar"
      },
      "MODALITA_POGACAR": {
        "title": "Pogačar-modus",
        "desc": "Win alle 3 de Grote Rondes en alle 5 de Monumenten"
      },
      "RE_CLASSICHE": {
        "title": "Koning van de Klassiekers",
        "desc": "Gewonnen klassiekers: {{n}}"
      },
      "RE_TAPPE": {
        "title": "Koning van de etappekoersen",
        "desc": "Gewonnen etappekoersen: {{n}}"
      },
      "WORLD_CHAMP": {
        "title": "Wereldkampioen",
        "desc": "Win de wegrit van de wereldkampioenschappen"
      },
      "EURO_CHAMP": {
        "title": "Europees kampioen",
        "desc": "Win de wegrit van de Europese kampioenschappen"
      },
      "CRONOMAN": {
        "title": "Tijdrijder",
        "desc": "Win een tijdrit van de wereld- of Europese kampioenschappen"
      },
      "SOLO_WIN": {
        "title": "Solo Win",
        "desc": "Enige in de competitie die de winnaar koos: {{n}}"
      },
      "PROFETA": {
        "title": "Profeet",
        "desc": "Winnende keuzes: {{n}}"
      },
      "FIUTO": {
        "title": "Neus voor winnaars",
        "desc": "Winnaars die weinigen kozen: {{n}}"
      },
      "LEAGUE_WINS": {
        "title": "Koerswinnaar",
        "desc": "Gewonnen koersen in de competitie: {{n}}"
      },
      "LEAGUE_PODI": {
        "title": "Vaste podiumgast",
        "desc": "Podiumplaatsen in competitiekoersen: {{n}}"
      },
      "DEBUTTO": {
        "title": "Debuut",
        "desc": "Speel je eerste koers"
      },
      "PRESENZE": {
        "title": "Aanwezigheid",
        "desc": "Gespeelde koersen: {{n}}"
      },
      "SERIE": {
        "title": "Op stoom",
        "desc": "Opeenvolgende gespeelde koersen: {{n}}"
      },
      "STAGIONE_PERFETTA": {
        "title": "Perfect seizoen",
        "desc": "Speel elke koers van het seizoen"
      },
      "LEADER_STAGIONE": {
        "title": "Aan de leiding",
        "desc": "Koersen afgesloten aan kop van het klassement: {{n}}"
      },
      "CAMPIONE_LEGA": {
        "title": "Competitiekampioen",
        "desc": "Sluit het seizoen af als eerste van het klassement"
      },
      "PODIO_LEGA": {
        "title": "Competitiepodium",
        "desc": "Sluit het seizoen af op het podium van het klassement"
      },
      "TOP10_LEGA": {
        "title": "Top 10",
        "desc": "Sluit het seizoen af in de top 10 van het klassement"
      },
      "SCALATORE": {
        "title": "Klimmer",
        "desc": "Plaatsen gewonnen in één koers: {{n}}"
      },
      "AMMAZZAGIANTI": {
        "title": "Reuzendoder",
        "desc": "Koersen afgesloten vóór de leider van het klassement: {{n}}"
      },
      "ALBUM": {
        "title": "Album",
        "desc": "Verdiende badges: {{n}}"
      },
      "LEGGENDA": {
        "title": "Legende",
        "desc": "Verdien alle badges"
      }
    },
    "celebration_one": "Nieuwe badge!",
    "celebration_many": "{{n}} nieuwe badges!",
    "celebration_more": "en nog {{n}}",
    "share": "Delen",
    "share_label": "BADGE BEHAALD",
    "share_dialog": "Mijn badge: {{name}}",
    "share_text": "Ik heb de badge “{{name}}” behaald op Virtua Cycling! {{site}}",
    "showcase_title": "Uitgelicht",
    "showcase_hint": "Kies tot 3 badges om te showen. Kies je niet, dan tonen we je zeldzaamste.",
    "showcase_edit": "Bewerken",
    "showcase_auto": "Automatisch",
    "showcase_save": "Opslaan",
    "showcase_count": "{{n}} van 3 gekozen",
    "showcase_err": "De selectie kon niet worden opgeslagen.",
    "showcase_a11y": "Je uitgelichte badges",
    "showcase_none": "Behaal je eerste badge om hem hier te zien.",
    "showcase_pick_empty": "Je hebt nog geen badges voor de vitrine.",
    "jerseys_title": "Truien van de Grote Rondes",
    "jersey_pink": "Roze trui",
    "jersey_yellow": "Gele trui",
    "jersey_red": "Rode trui",
    "days_caption": "Dagen in de trui",
    "section_jerseys": "Truien",
    "special_title": "Speciale truien",
    "special_now": "Nu gedragen",
    "trophy_sub": "Badges, truien en erelijst"
  },
  "rivalry": {
    "title": "Uitdagingen",
    "intro": "Kies een tegenstander. Als hij accepteert, scoort vanaf die koers degene die voor de ander eindigt het punt. De hele competitie ziet hoe het staat.",
    "slots": "Verstuurde uitdagingen: {{used}} van {{max}}",
    "limit_reached": "Je hebt het maximum aantal uitdagingen verstuurd. Annuleer of beëindig er een om een nieuwe te sturen.",
    "no_candidates": "Er zijn geen andere spelers om uit te dagen.",
    "challenge_cta": "Een uitdaging sturen",
    "pick_title": "Wie wil je uitdagen?",
    "confirm_challenge": "{{name}} uitdagen? Hij ontvangt het verzoek en kan accepteren of weigeren.",
    "sent": "Verzoek verstuurd naar {{name}}.",
    "accepted": "Je hebt de uitdaging met {{name}} geaccepteerd.",
    "incoming_title": "Ontvangen verzoeken",
    "incoming_line": "{{name}} daagt je uit",
    "accept": "Accepteren",
    "decline": "Weigeren",
    "waiting_title": "Wachten op antwoord",
    "waiting_line": "Wachten op {{name}}",
    "cancel": "Annuleren",
    "mine_title": "Jouw uitdagingen",
    "league_title": "In de competitie",
    "ended_title": "Afgeronde uitdagingen: {{count}}",
    "empty": "Geen lopende uitdagingen in de competitie. Stuur de eerste!",
    "vs": "tegen",
    "score_a11y": "{{a}} om {{b}}",
    "last_point": "Laatste punt: {{name}} in {{race}}",
    "no_races": "Nog geen koersen",
    "won_by": "Gewonnen door {{name}}",
    "drawn": "Geëindigd in een gelijkspel",
    "detail_title": "Uitdaging",
    "results_title": "Koers voor koers",
    "no_results": "Nog geen punten toegekend.",
    "point_to": "Punt voor {{name}}",
    "end_cta": "De uitdaging beëindigen",
    "end_confirm": "De uitdaging met {{name}} beëindigen?",
    "rematch": "Revanche",
    "load_error": "De uitdagingen konden niet worden geladen.",
    "err_limit": "Je hebt al het maximum aantal uitdagingen verstuurd.",
    "err_exists": "Jullie zijn al in een uitdaging, of er loopt een verzoek.",
    "err_invalid": "Dit verzoek is niet meer geldig.",
    "err_generic": "De actie kon niet worden voltooid.",
    "notif_accepted": "Uitdaging geaccepteerd",
    "notif_declined": "Uitdaging geweigerd"
  },
  "competition": {
    "men": "Men Elite",
    "women": "Women Elite",
    "aria": "Competitie"
  },
  "no_league": {
    "title": "Je doet niet mee aan een {{comp}}-league",
    "body": "Je kunt meedoen aan een league of een nieuwe maken via het onderdeel Leagues.",
    "body_official": "Je kunt wanneer je wilt meedoen aan de officiële league, of meedoen aan of een privé-league maken via het onderdeel Leagues.",
    "join": "Doe mee met {{name}}",
    "go_leagues": "Naar de leagues"
  }
}
